import { styled } from '@clickcease/cc-client-components-lib'

export const SelectProductContainer = styled('div', {
  paddingRight: '$1',
})

export const SelectItem = styled('span', {
  display: 'flex',
  alignItems: 'center',
  fontSize: '$md',
  color: '$mainTextColor',
  cursor: 'pointer',

  variants: {
    leftPadding: {
      true: {
        paddingLeft: '$4',
      },
    },
    light: {
      true: {
        color: '$disabled',
      },
    },
  },
})

export const generalSelectStyle = (selectAll: boolean) => {
  // Add border to the bottom of the select all option
  const selectAllStyle = selectAll
    ? {
        '[class$="MenuList"] > div:first-of-type': {
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'relative',
            display: 'block',
            width: 182,
            marginTop: 'var(--space-4)',
            borderBottom: `1px solid var(--colors-gradient)`,
          },
        },
      }
    : {}
  return {
    width: 284,
    maxWidth: '100%',
    ...selectAllStyle,
    // Hide the remaining products numbers
    '[class$="multiValue"] div > span span': {
      display: 'none',
    },
  }
}
